
import { defineComponent, PropType } from 'vue';
import { renderMarkdown } from '@/utils/markdown';

interface ChatMessage {
  id?: number;
  senderType: string;
  messageContent: string;
  messageType: string;
  sendTime?: string;
}

export default defineComponent({
  name: 'SmartCsChatDialog',
  props: {
    visible: { type: Boolean, default: false },
    messages: { type: Array as PropType<ChatMessage[]>, default: () => [] },
    loading: { type: Boolean, default: false },
    sending: { type: Boolean, default: false },
    humanServiceUrl: { type: String, default: '' }
  },
  data() {
    return {
      inputText: ''
    };
  },
  mounted() {
    // 将对话框移动到 body 下，避免 Widget 框架容器内的 transform 等属性破坏 position:fixed 定位
    document.body.appendChild(this.$el);
  },
  beforeUnmount() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  watch: {
    messages: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      deep: true
    }
  },
  methods: {
    renderMarkdown,
    onSend() {
      const text = this.inputText.trim();
      if (!text) return;
      this.$emit('send', text);
      this.inputText = '';
    },
    onClose() {
      this.$emit('close');
    },
    openHumanService() {
      this.$emit('openHumanService');
    },
    scrollToBottom() {
      const container = this.$refs.messagesContainer as HTMLElement;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },
    formatTime(time: string) {
      if (!time) return '';
      try {
        const d = new Date(time);
        return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
      } catch {
        return '';
      }
    }
  }
});
